import URL from '../url'
import Request from '../request'

/**
 *
 * @param {*} content
 */
export const cardPatchService = content =>
  new Request(URL.API, URL.CARD_PATCH + '?id=' + content.id).patch(content)

/**
 * @param {*} id
 *
 */
export const cardSettingPatchService = content => {
  new Request(URL.API, URL.PATCH_SETTING + '?id=' + content.id).patch(
    content.data,
  )
}

/**
 * @param {*} id
 *
 */
export const cardSettingCreateService = content =>
  new Request(URL.API, URL.CREATE_SETTING).post(content)

export const cardSettingRemoveService = id =>
  new Request(URL.API, URL.REMOVE_SETTING).delete({ id })

/**
 *
 * @param {*} content
 */
export const cardSelectionPatchService = content =>
  new Request(URL.API, URL.PATCH_SELECTION + '?id=' + content.id).patch(content)

/**
 *
 * @param {*} entity
 */
export const cardMediaAddService = entity =>
  new Request(URL.API, URL.ADD_CARD_MEDIA).post(entity)

/**
 *
 * @param {*} entity
 */
export const cardSelectionAddService = entity =>
  new Request(URL.API, URL.ADD_CARD_SELECTION).post(entity)

/**
 *
 * @param {*} id
 */
export const cardMediaDeleteService = id =>
  new Request(URL.API, URL.DELETE_CARD_MEDIA).delete({ id })

/**
 *
 * @param {*} id
 */
export const cardLinkDeleteService = id =>
  new Request(URL.API, URL.DELETE_CARD_LINK).delete({ id })
/**
 *
 * @param {*} id
 */
export const cardSelectionDeleteService = id =>
  new Request(URL.API, URL.DELETE_CARD_SELECTION).delete({ id })

/**
 *
 * @param {*} entity
 * @param {*} courseId
 */
export const cardAddInsideCourseService = (entity, courseId) =>
  new Request(URL.API, URL.ADD_CARD_INSIDE_COURSE).post({
    ...entity,
    courseId: courseId,
  })

export const createCustomerPortalSession = () =>
  new Request(URL.API, URL.CREATE_CUSTOMER_PORTAL_SESSION).post({})

/**
 *
 * @param {*} id
 */
export const getSertifierDeliveries = CardId =>
  new Request(URL.API, URL.GET_SERTIFIER_DELIVERIES).get({ CardId })

/**
 *
 */
export const courseRemoveCardService = (cardId, courseId) => {
  return new Request(URL.API, URL.REMOVE_QUESTION_ASSIGNMENT).post({
    id: courseId,
    cardIds: [cardId],
  })
}
/**
 *
 *
 */
export const courseCardLinkPatchService = content =>
  new Request(URL.API, URL.CARD_PATCH_LINK + '?id=' + content.id).patch(content)

/**
 * @param {*} content
 */

export const addCardService = content =>
  new Request(URL.API, URL.ADD_CARD).post(content)

export const deleteSectionService = id =>
  new Request(URL.API, URL.DELETE_SECTION.replace('{id}', id)).delete()

export const getCardService = id =>
  new Request(URL.API, URL.GET_CARD.replace('{id}', id)).get()
